export const categories = [
  {
    slug: 'role-playing',
    name: '角色扮演',
    icon: 'ri-user-star-line',
    description: '沉浸式火影忍者角色扮演游戏，扮演你最喜欢的忍者角色展开冒险',
    keyword: '火影同人角色扮演游戏',
  },
  {
    slug: 'fighting',
    name: '格斗对战',
    icon: 'ri-sword-line',
    description: '热血激燃的火影同人格斗游戏，体验忍术对决的快感',
    keyword: '火影同人格斗游戏',
  },
  {
    slug: 'strategy',
    name: '策略养成',
    icon: 'ri-brain-line',
    description: '策略与养成结合的火影忍者同人RPG，打造你的忍者军团',
    keyword: '火影忍者同人RPG',
  },
  {
    slug: 'mobile',
    name: '手机游戏',
    icon: 'ri-smartphone-line',
    description: '随时随地畅玩的火影同人手游合集',
    keyword: '火影同人手游',
  },
  {
    slug: 'adventure',
    name: '冒险探索',
    icon: 'ri-compass-3-line',
    description: '在忍者世界中自由探索的火影同人冒险游戏',
    keyword: '火影同人免费游戏',
  },
  {
    slug: 'multiplayer',
    name: '多人联机',
    icon: 'ri-group-line',
    description: '与朋友一起组队冒险的多人火影同人游戏',
    keyword: '火影同人游戏',
  },
];

export const games = [
  {
    id: 1,
    title: '忍者之路：羁绊',
    slug: 'ninja-path-bonds',
    category: 'role-playing',
    image: 'https://readdy.ai/api/search-image?query=Anime%20style%20Naruto%20ninja%20game%20cover%20art%20with%20naruto%20uzumaki%20character%20in%20orange%20jumpsuit%20standing%20on%20wooden%20rooftop%20at%20sunset%2C%20dramatic%20lighting%2C%20warm%20orange%20and%20gold%20tones%2C%20game%20cover%20design%2C%20high%20quality%20illustration%20with%20soft%20background%20blur&width=800&height=600&seq=naruto-game-01&orientation=landscape',
    description: '扮演鸣人踏上忍者之路，体验从下忍到火影的完整成长历程，与佐助、小樱一起完成S级任务。',
    rating: 4.8,
    plays: '128,000',
    tags: ['剧情丰富', '开放世界', '角色成长'],
  },
  {
    id: 2,
    title: '忍界大战：究极风暴',
    slug: 'ninja-war-ultimate',
    category: 'fighting',
    image: 'https://readdy.ai/api/search-image?query=Epic%20Naruto%20fighting%20game%20art%20with%20two%20ninjas%20clashing%20in%20mid%20air%20with%20chakra%20energy%20effects%2C%20dynamic%20action%20pose%2C%20anime%20style%20illustration%2C%20vibrant%20blue%20and%20orange%20energy%2C%20dark%20dramatic%20background%2C%20game%20poster%20design&width=800&height=600&seq=naruto-game-02&orientation=landscape',
    description: '究极风暴级火影格斗游戏，收录超过100位忍者角色，还原经典忍术对决，支持在线PVP对战。',
    rating: 4.9,
    plays: '256,000',
    tags: ['格斗竞技', '在线对战', '技能组合'],
  },
  {
    id: 3,
    title: '忍者村物语',
    slug: 'ninja-village-story',
    category: 'strategy',
    image: 'https://readdy.ai/api/search-image?query=Japanese%20village%20building%20game%20scene%20with%20wooden%20houses%20and%20cherry%20blossom%20trees%2C%20ninja%20village%20management%20theme%2C%20warm%20sunlight%2C%20cozy%20anime%20game%20art%20style%2C%20top%20down%20perspective%2C%20soft%20pastel%20colors&width=800&height=600&seq=naruto-game-03&orientation=landscape',
    description: '建造你自己的忍者村，招募忍者学员，培养强大的忍者团队，抵御敌人的入侵，成为最强忍村。',
    rating: 4.6,
    plays: '89,000',
    tags: ['村庄建设', '策略经营', '回合制'],
  },
  {
    id: 4,
    title: '火影忍者：疾风乱斗',
    slug: 'naruto-storm-clash',
    category: 'mobile',
    image: 'https://readdy.ai/api/search-image?query=Mobile%20game%20screenshot%20of%20Naruto%20anime%20style%20card%20battle%20game%2C%20colorful%20character%20cards%20with%20ninja%20portraits%2C%20bright%20UI%20design%2C%20cute%20chibi%20art%20style%2C%20vibrant%20colors%2C%20mobile%20game%20interface&width=800&height=600&seq=naruto-game-04&orientation=landscape',
    description: '随时随地畅玩的火影手游，精致的卡牌对战玩法，收集你喜爱的忍者角色组建最强阵容。',
    rating: 4.7,
    plays: '512,000',
    tags: ['卡牌收集', '回合对战', '手机游戏'],
  },
  {
    id: 5,
    title: '忍者世界：自由探索',
    slug: 'ninja-world-explore',
    category: 'adventure',
    image: 'https://readdy.ai/api/search-image?query=Open%20world%20anime%20game%20landscape%20with%20vast%20green%20fields%20and%20mountains%2C%20ninja%20character%20running%20through%20the%20scene%2C%20beautiful%20stylized%20nature%2C%20adventure%20game%20atmosphere%2C%20warm%20lighting%2C%20anime%20style%20illustration&width=800&height=600&seq=naruto-game-05&orientation=landscape',
    description: '在广阔的忍者世界中自由冒险，探索隐藏的秘术卷轴，解锁传说中的血继限界，书写你自己的忍者传奇。',
    rating: 4.5,
    plays: '76,000',
    tags: ['开放世界', '自由探索', '隐藏要素'],
  },
  {
    id: 6,
    title: '晓组织：暗影行动',
    slug: 'akatsuki-shadow-ops',
    category: 'role-playing',
    image: 'https://readdy.ai/api/search-image?query=Dark%20anime%20game%20art%20featuring%20robed%20ninja%20characters%20with%20red%20cloud%20pattern%2C%20mysterious%20atmosphere%2C%20night%20scene%20with%20moon%2C%20stealth%20action%20theme%2C%20dramatic%20shadows%2C%20cool%20dark%20red%20and%20black%20color%20scheme&width=800&height=600&seq=naruto-game-06&orientation=landscape',
    description: '以晓组织成员的身份执行秘密任务，收集尾兽的力量，在黑暗中追寻忍界和平的真正含义。',
    rating: 4.7,
    plays: '192,000',
    tags: ['反派视角', '暗杀任务', '剧情分支'],
  },
  {
    id: 7,
    title: '忍界学院',
    slug: 'ninja-academy',
    category: 'strategy',
    image: 'https://readdy.ai/api/search-image?query=Anime%20school%20academy%20scene%20with%20young%20ninja%20students%20training%20in%20courtyard%2C%20wooden%20buildings%2C%20cherry%20blossoms%2C%20bright%20sunny%20day%2C%20colorful%20anime%20art%20style%2C%20wholesome%20atmosphere&width=800&height=600&seq=naruto-game-07&orientation=landscape',
    description: '成为忍者学院的校长，培养新一代的忍者精英，安排课程训练、团队任务和实战演练。',
    rating: 4.4,
    plays: '65,000',
    tags: ['模拟经营', '教育养成', '轻松休闲'],
  },
  {
    id: 8,
    title: '火影无双：忍界割草',
    slug: 'naruto-musou',
    category: 'fighting',
    image: 'https://readdy.ai/api/search-image?query=Action%20game%20scene%20with%20ninja%20character%20fighting%20multiple%20enemies%20with%20special%20attack%20effects%2C%20dynamic%20combat%2C%20anime%20style%2C%20energy%20explosions%2C%20battlefield%20setting%2C%20epic%20action%20game%20poster&width=800&height=600&seq=naruto-game-08&orientation=landscape',
    description: '无双风格的火影格斗游戏，以一敌百的爽快战斗体验，释放华丽的忍术连招横扫战场。',
    rating: 4.6,
    plays: '143,000',
    tags: ['无双割草', '爽快战斗', '技能特效'],
  },
  {
    id: 9,
    title: '火影忍者：羁绊物语',
    slug: 'naruto-bond-story',
    category: 'mobile',
    image: 'https://readdy.ai/api/search-image?query=Cute%20chibi%20Naruto%20characters%20in%20visual%20novel%20style%20game%2C%20colorful%20dialog%20scene%2C%20friendship%20and%20adventure%20theme%2C%20bright%20and%20warm%20colors%2C%20mobile%20game%20art%2C%20kawaii%20anime%20illustration&width=800&height=600&seq=naruto-game-09&orientation=landscape',
    description: '轻松愉快的火影同人剧情手游，与鸣人、佐助等角色建立羁绊，解锁专属剧情故事线。',
    rating: 4.5,
    plays: '234,000',
    tags: ['剧情互动', '羁绊系统', '休闲养成'],
  },
  {
    id: 10,
    title: '忍者跑酷：木叶疾走',
    slug: 'ninja-parkour-konoha',
    category: 'adventure',
    image: 'https://readdy.ai/api/search-image?query=Fast%20paced%20anime%20parkour%20game%20scene%20with%20ninja%20running%20on%20rooftops%20in%20village%20setting%2C%20speed%20lines%2C%20dynamic%20movement%2C%20colorful%20village%20background%2C%20action%20packed%20game%20art%2C%20vibrant%20colors&width=800&height=600&seq=naruto-game-10&orientation=landscape',
    description: '在木叶村的屋顶上飞檐走壁，收集查克拉能量，躲避障碍物，挑战最快的忍者跑酷纪录。',
    rating: 4.3,
    plays: '178,000',
    tags: ['跑酷动作', '竞速挑战', '收集要素'],
  },
  {
    id: 11,
    title: '忍术大师：元素掌控',
    slug: 'ninjutsu-master-elements',
    category: 'fighting',
    image: 'https://readdy.ai/api/search-image?query=Ninja%20character%20casting%20elemental%20magic%20with%20fire%20water%20wind%20earth%20lightning%20effects%2C%20anime%20style%20spell%20casting%2C%20magical%20battle%20arena%2C%20colorful%20elemental%20effects%2C%20dynamic%20pose%2C%20game%20cover%20art&width=800&height=600&seq=naruto-game-11&orientation=landscape',
    description: '掌握五大性质变化的忍术系统，自由组合元素创造独特的忍术，在竞技场中展现你的忍术天赋。',
    rating: 4.8,
    plays: '201,000',
    tags: ['元素组合', '技能自定义', '竞技对战'],
  },
  {
    id: 12,
    title: '火影传说：忍者纪元',
    slug: 'naruto-legend-era',
    category: 'role-playing',
    image: 'https://readdy.ai/api/search-image?query=Epic%20fantasy%20anime%20game%20cover%20with%20group%20of%20ninja%20heroes%20standing%20on%20cliff%20overlooking%20village%2C%20sunset%20sky%2C%20adventure%20theme%2C%20beautiful%20landscape%2C%20warm%20golden%20light%2C%20rich%20detailed%20illustration&width=800&height=600&seq=naruto-game-12&orientation=landscape',
    description: '经典回合制RPG火影同人游戏，穿越忍者历史的不同纪元，见证忍界大事件，与传奇忍者并肩作战。',
    rating: 4.9,
    plays: '320,000',
    tags: ['回合制RPG', '史诗剧情', '角色收集'],
  },
];